module.exports = __webpack_public_path__ + "img/logo-clearmortgagecapital White.aaeca842.svg";